import { useState } from 'react';

// Ce hook gère l'état et la navigation entre les deux étapes de la modale.
export const useRecurrenceFlow = ({ onFinalSave }) => {
    // 1. Contrôle l'ouverture des modales
    const [showRecurrenceModal, setShowRecurrenceModal] = useState(false);
    const [showRecurrenceMonthsModal, setShowRecurrenceMonthsModal] = useState(false);
    
    // 2. Stocke les données collectées à l'étape 1 (passées à l'étape 2)
    const [dataForMonthsModal, setDataForMonthsModal] = useState(null);

    // Fonction d'ouverture par le bouton "Nouvelle récurrence"
    const openNewRecurrence = () => {
        setDataForMonthsModal(null); // S'assurer que c'est une création
        setShowRecurrenceModal(true);
    };

    // Gère la transition : Étape 1 (RecurrenceModal) -> Étape 2 (RecurrenceMonthsModal)
    const handleNextStep = (data) => {
        setDataForMonthsModal(data);
        setShowRecurrenceModal(false);
        setShowRecurrenceMonthsModal(true);
    };

    // Gère la fermeture de l'étape 1
    const handleCloseRecurrenceModal = () => {
        setShowRecurrenceModal(false);
    };

    // Gère la fermeture de l'étape 2 et la sauvegarde finale
    const handleCloseMonthsModal = (finalData) => {
        setShowRecurrenceMonthsModal(false);
        if (finalData) {
            onFinalSave(finalData); // Appelle la fonction de sauvegarde POST/PUT implémentée dans le composant parent
        }
    };
    
    // Retourne l'état et les gestionnaires nécessaires
    return {
        showRecurrenceModal,
        showRecurrenceMonthsModal,
        dataForMonthsModal,
        openNewRecurrence,
        handleNextStep,
        handleCloseRecurrenceModal,
        handleCloseMonthsModal,
    };
};